import { LayerEntity } from '../entities/layer-entity';
import { LayerTypeEnum } from '../enums/layer-type-enum';
import { GfwTileValueObject } from '../value-objects/gfw-tile-value-object';

/**
 * Capas de alertas de Global Forest Watch (GLAD/RADD): definición de los tiles
 * disponibles y reglas de consulta del dato por año.
 */
export class GfwConstant {
  static readonly TILES: GfwTileValueObject[] = [
    new GfwTileValueObject('gfw-integrated', 'Alertas Integradas', 'gfw_integrated_dist_alerts', 1),
    new GfwTileValueObject('gfw-glad-landsat', 'GLAD-L', 'umd_glad_landsat_alerts'),
    new GfwTileValueObject('gfw-glad-s2', 'GLAD-S2', 'umd_glad_sentinel2_alerts'),
    new GfwTileValueObject('gfw-radd', 'RADD', 'wur_radd_alerts'),
  ];

  static readonly YEAR_MIN = 2015;
  static readonly YEAR_MAX = new Date().getFullYear();

  /** URL del tile de un dataset GFW filtrado por año. */
  static tileUrl(dataset: string, year: number): string {
    return `https://tiles.globalforestwatch.org/${dataset}/latest/dynamic/{z}/{x}/{y}.png?start_date=${year}-01-01&end_date=${year}-12-31`;
  }

  /** Grupo de alertas GFW listo para el árbol de capas de monitoreo. */
  static buildGroup(): LayerEntity {
    return new LayerEntity({
      id: 'gfw-alerts',
      name: 'Global Forest Watch',
      type: LayerTypeEnum.Group,
      visible: false,
      opacity: 1,
      layers: this.TILES.map(
        tile =>
          new LayerEntity({
            id: tile.id,
            name: tile.name,
            type: LayerTypeEnum.WebTile,
            url: this.tileUrl(tile.dataset, this.YEAR_MAX),
            visible: false,
            opacity: tile.opacity ?? 0.85,
          })
      ),
    });
  }
}